// extracted by mini-css-extract-plugin
export default {"component":"hEnilN","message":"AUnD1V"};